<div class="flex h-full min-h-0 flex-col">
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="flex w-full shrink-0 justify-between">
      <div class="flex items-center">
        @if (showBackIcon) {
          <div
            class="flex items-center justify-center w-[34px] h-[42px] bg-[#f3f4f6] rounded-[8.4px] cursor-pointer hover:bg-gray-200 transition-colors"
            [class.hidden]="view === 'ordering' && startedAtOrdering"
            (click)="onPrev()">
            <mat-icon
              class="material-symbols-rounded !text-[21px] !w-[21px] !h-[21px] text-[#111827]">
              keyboard_backspace
            </mat-icon>
          </div>
        }
      </div>
      <div>
        <mat-icon
          class="material-symbols-rounded scale-100 cursor-pointer"
          (click)="onCloseDialog()">
          close
        </mat-icon>
      </div>
    </div>
    <div
      class="flex min-h-0 flex-1 flex-col overflow-y-auto"
      [class.items-center]="!isOfferSelectionView"
      [class.justify-center]="!isOfferSelectionView"
      [class.justify-start]="isOfferSelectionView">
      <div
        class="flex w-full max-w-[1724px] flex-1 flex-col self-center px-4 md:px-14"
        [class.py-10]="!isOfferSelectionView"
        [class.pb-10]="isOfferSelectionView">
        <div class="flex w-full flex-1 flex-col">
          @if (isOfferSelectionView) {
            <!-- Same Leistungstabelle as `SchoolOnboarding` «Angebot» / Fachkraft `upgradeOffers` (role-bound). -->
            <div class="flex w-full flex-col gap-4 pt-16">
              <app-order-process-products
                class="w-full"
                [role]="orderProcessProductsRole()"
                [schoolUnitOffersOnboardingLayout]="
                  shouldEmbedSchoolUnitOnboardingOffers()
                "
                [showNegotiatedOffer]="showNegotiatedOfferForDialog()"
                (selectOffer)="onSelectOffer($event)" />
            </div>
          } @else if (view === 'ordering' && selectedOffer) {
            <app-order-process-ordering
              #stepperContainer
              class="-mt-9 md:-mt-[93px]"
              [subscriptionType]="selectedOffer"
              [upgradeId]="createdId"
              [upgradeRole]="upgradeRole"
              (closeDialog)="onCloseDialog()" />
          } @else if (view === 'roleSelect') {
            <app-upgrade-role-selector
              class="w-full"
              (roleSelected)="onSelectUpgradeRole($event)" />
          } @else if (view === 'memberBlocked') {
            <div
              class="flex w-full max-w-[520px] flex-col items-center gap-4 self-center text-center">
              <mat-icon
                class="material-symbols-rounded !h-12 !w-12 !text-[48px] text-[#111827]">
                lock_person
              </mat-icon>
              <h2 class="text-2xl font-semibold text-[#111827]">
                Abos verwaltet der Eigentümer
              </h2>
              <p class="text-base text-[#6b7280]">
                Du bist als Admin einer Organisation hinterlegt. Abonnemente und
                Käufe werden von der Eigentümerin bzw. dem Eigentümer der
                Organisation verwaltet — du bist über deren Abo bereits
                freigeschaltet.
              </p>
              <button
                type="button"
                class="mt-2 rounded-[8px] bg-[#111827] px-6 py-3 text-white hover:bg-black transition-colors"
                (click)="onCloseDialog()">
                Verstanden
              </button>
            </div>
          } @else if (view === 'upgradeSchoolUnit') {
            <app-upgrade-school-unit-step4
              class="w-full"
              [initialDraft]="lastSchuleinheitStep4"
              (step4DraftChange)="onSchuleinheitStep4Draft($event)"
              (formSubmitted)="onStep4Submitted($event)"
              (goBack)="onPrev()" />
          } @else if (view === 'upgradeSchoolAuthority') {
            <app-upgrade-school-authority-step4
              class="w-full"
              [initialDraft]="lastSchulgemeindeStep4"
              (step4DraftChange)="onSchulgemeindeStep4Draft($event)"
              (formSubmitted)="onStep4Submitted($event)"
              (goBack)="onPrev()" />
          } @else if (
            view === 'upgradeSummary' && upgradeSummaryData && upgradeRole
          ) {
            <app-upgrade-summary
              class="w-full"
              [summaryData]="upgradeSummaryData.form"
              [role]="upgradeRole"
              [loading]="loading"
              (editProfile)="onSummaryEdit()"
              (createProfile)="onSummaryCreate()" />
          } @else if (view === 'upgradeOrderingAuthority') {
            <app-upgrade-ordering-authority
              class="w-full"
              (orderCompleted)="onOrderCompleted()"
              (firstMonthsFreeChange)="firstMonthsFreePromo = $event"
              (goBack)="onPrev()" />
          } @else if (view === 'upgradeOrderingUnit') {
            <app-upgrade-ordering-unit
              class="w-full"
              [billingOrganisation]="existingSchuleinheitBillingOrganisation"
              (orderCompleted)="onSchuleinheitUnitOrderCompleted($event)"
              (firstMonthsFreeChange)="firstMonthsFreePromo = $event"
              (goBack)="onPrev()" />
          } @else if (view === 'upgradeOrderSuccess') {
            <div class="flex w-full items-center justify-center py-10">
              <div
                class="mx-auto flex w-full max-w-[520px] flex-col gap-4 sm:gap-5">
                <div
                  class="w-full rounded-[12px] bg-white px-5 pb-6 pt-6 shadow-[0px_12px_24px_-4px_rgba(0,0,0,0.08),0px_4px_8px_-2px_rgba(0,0,0,0.06)] sm:px-8 sm:pt-7 sm:pb-7">
                  <div class="flex flex-col items-center">
                    <div
                      class="mb-4 flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#dcfce7]">
                      <mat-icon
                        class="material-symbols-rounded !h-10 !w-10 !text-[40px] text-green-600"
                        >check_circle</mat-icon
                      >
                    </div>
                    <h1
                      class="m-0 mb-1 text-center font-bold text-2xl min-[360px]:text-3xl text-[#0a0a0a]">
                      Bestellung erfolgreich!
                    </h1>
                    <p class="m-0 mb-5 text-center text-base text-bn-bright">
                      Vielen Dank für deine Bestellung.
                    </p>
                    <div
                      class="flex w-full flex-col gap-3 rounded-[10px] border border-[#bedbff] bg-[#eff6ff] px-4 py-4 sm:px-5">
                      <div class="flex gap-3">
                        <mat-icon
                          class="material-symbols-rounded mt-0.5 shrink-0 !text-[18px] text-[#1e40af]"
                          >description</mat-icon
                        >
                        <div class="min-w-0 flex-1">
                          <p class="m-0 text-base font-semibold text-[#111827]">
                            Rechnung
                          </p>
                          @if (firstMonthsFreePromo) {
                            <p class="m-0 mt-0.5 text-sm text-[#717182]">
                              Sofern du nicht kündigst, wird dir nach Ablauf der
                              kostenlosen Phase die Rechnung automatisch
                              zugestellt.
                            </p>
                          } @else {
                            <p class="m-0 mt-0.5 text-sm text-[#717182]">
                              Die Rechnung wird in Kürze an
                              <span class="font-medium text-[#0a0a0a]"
                                >deine E-Mail</span
                              >
                              gesendet.
                            </p>
                          }
                        </div>
                      </div>
                      <div class="flex gap-3">
                        <mat-icon
                          class="material-symbols-rounded mt-0.5 shrink-0 !text-[18px] text-[#1e40af]"
                          >check_circle</mat-icon
                        >
                        <div class="min-w-0 flex-1">
                          <p class="m-0 text-base font-semibold text-[#111827]">
                            Zugang
                          </p>
                          <p class="m-0 mt-0.5 text-sm text-[#717182]">
                            Dein Abonnement ist sofort aktiv. Du kannst jetzt
                            direkt loslegen!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  mat-flat-button
                  color="primary"
                  class="w-full"
                  (click)="onOrderSuccessContinue()">
                  {{
                    upgradeRole === 'schuleinheit'
                      ? 'Zum Dashboard'
                      : 'Weiter zur Profilerstellung'
                  }}
                  <mat-icon iconPositionEnd class="material-symbols-rounded"
                    >arrow_forward</mat-icon
                  >
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
